import { requestWithToken as request } from "./api";

export const createRecurrency = (data = {}) =>
    request.post("/recurring_payment/?format=json", data);

export const updateRecurrency = (data = {}) =>
    request.patch(`/recurring_payment/${data.id}/?format=json`, data.field);

export const deleteRecurrency = (data = {}) =>
    request.delete(`/recurring_payment/${data}/?format=json`);
